module.exports = __webpack_public_path__ + "img/double-ipa.a730e245.jpg";